// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/0b5a8e804c773dc207db.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3e9bc9879d5972de0c99","122":"f5b49dd001b39684b3ba","123":"4368d99bf46acd366540"}[chunkId] + ".chunk.js";
};